import React from "react";
import "./LeftImgCard.scss";
export default function LeftImgCard(props) {
  return (
    <div className="cardBase">
      <div className="cardContent">
        <div className="cardLeftGrid1">
          <div className="imgBase">
            <img src={props.img} alt="cardImg" className="cardImg" />
          </div>
        </div>
        <div className="cardRightGrid">
          <div className="textBase">
            <p className="cardTitleTxt1">{props.title}</p>
            <p className="cardSubTxt">{props.desp}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
